module.exports = __webpack_public_path__ + "static/media/Epilogue-MediumItalic.d9294826.ttf";